define.alias("shared/components/shared/profile-categorization/icons", "settings/components/shared/profile-categorization/icons");